import React, { useEffect, useState } from 'react';

import { Button, ButtonGroup, Heading, Modal, Text, TextButton } from '@zillow/constellation-10';

type Props = {
  canPublish: boolean;
  displayModal: boolean;
  hasNextStep: boolean;
  onClose: () => void;
  onCancel?: () => void;
  onSubmit?: () => void;
};

const contentCanPublish =
  'Your progress will be saved but the listing won’t be published for renters to view. If you want to publish now, continue to the next step.';

const contentCanNotPublish =
  'Your progress will be saved, but your listing isn’t complete or published. If you want to publish it, finish editing the sections shown as incomplete.';

const SaveAndExitModal = ({
  canPublish,
  displayModal: aDisplayModal,
  hasNextStep,
  onCancel = () => {},
  onClose,
  onSubmit = () => {},
}: Props) => {
  const [displayModal, setDisplayModal] = useState(aDisplayModal);

  useEffect(() => {
    setDisplayModal(aDisplayModal);
  }, [aDisplayModal]);

  const heading = canPublish ? 'Exit without publishing?' : 'Exit without completing?';
  const bodyContent = canPublish ? contentCanPublish : contentCanNotPublish;
  const cancelText = canPublish && hasNextStep ? 'No, go to next step' : 'Edit listing';
  const submitText = canPublish ? 'Yes, exit' : 'Exit now';

  if (!displayModal) {
    return null;
  }

  return (
    <Modal
      open={displayModal}
      onOpenChange={(open) => !open && onClose()}
      size={{ base: 'fullScreen', lg: 'md' }}
      body={
        <div>
          <Heading level={4} css={{ marginBottom: '400' }}>
            {heading}
          </Heading>
          <Text data-test="SaveAndExitModal">{bodyContent}</Text>
        </div>
      }
      footer={
        <ButtonGroup aria-label="Save and exit footer">
          <TextButton onClick={onCancel}>{cancelText}</TextButton>
          <Button emphasis="filled" onClick={onSubmit}>
            {submitText}
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default SaveAndExitModal;
